









































import {Vue,Component} from 'vue-property-decorator'
import TablaGeneralFinalComponent from '@/components/General/TablaGeneralFinal.vue';
import Formulario from '@/components/Maestro/Espesor/Formulario.vue'
import {Espesor, EditarEstadoEspesor, ObtenerEspesor} from '@/entidades/Maestro/Ktb/Espesor';
import { Action } from 'vuex-class';
import Alerta from '@/entidades/Sistema/Alerta';
import Loading from '@/entidades/Sistema/Loading';
@Component({
    components:{
        'Tabla' : TablaGeneralFinalComponent,
        'Formulario' :Formulario
    }
})
export default class EspesorVie extends Vue
{
    @Action('changeLoading',{namespace:'sistemaModule'}) changeLoading!:Function;
    @Action('changeAlerta',{namespace:'sistemaModule'}) changeAlerta!:Function;
    header:{text:string,sortable:boolean,value:string}[] =
    [
            {text:"Descripcion",sortable:true,value:'descripcion'},
            {text:"Tipo",sortable:true,value:'tipo'},
            {text:"Plantilla",sortable:true,value:'plantilla'},
            {text:"Factor Hueco",sortable:true,value:'factorHueco'},
            {text:"Factor Hueco Tablon",sortable:true,value:'factorHuecoTablon'},
            {text:"Action",sortable:false,value:'actions'},
            {text:"Estado",sortable:true,value:'estado'}            
    ];
    modal:boolean=false;
    currentComponent:string="";
    listado:Array<Espesor> = [];
    modelo:Espesor |undefined= undefined;
    actions:number =1;
    async editarEstado(espesor:Espesor)
    {
        try
        {
            this.changeLoading(new Loading(true,"Editando informacion"));
            let rsp = await EditarEstadoEspesor(espesor);
            if(rsp.isSuccess == true)
            {
                this.limpiar();
            }
            else 
            {
                this.changeAlerta(new Alerta(rsp.isMessage,true,"danger",3000));
            }
        }
        catch(error)
        {
            
        }
        finally
        {
            this.changeLoading(new Loading(false,""));
        }
    }

    async abrilModal()
    {
        this.actions = 1;
        this.currentComponent = 'Formulario';
        this.modal= true;
    }
    editarModal(espesor:Espesor)
    {
        this.currentComponent = "Formulario";
        this.actions = 2;
        this.modelo = espesor;
        this.modal = true;
    }

    async Obtener()
    {
        try
        {
            this.changeLoading(new Loading(true,"Cargando informacion"));
            let rsp = await ObtenerEspesor();
            if(rsp.isSuccess == true)
            {
                this.listado = rsp.isResult;
            }
            else
            {
                this.changeAlerta(new Alerta(rsp.isMessage,true,"danger",3000));
            }
        }
        catch(error)
        {
            console.log(error);
        }
        finally
        {
            this.changeLoading(new Loading(false,""));
        }
    }

    limpiar()
    {
        this.Obtener();
        this.currentComponent = '';
        this.modal = false;
    }

    get getPropiedades()
    {
       if(this.currentComponent == "Formulario")
        {
            return {'action' :this.actions, 'modelo' :this.modelo};
        }
    }


    mounted() {
     this.Obtener();   
    }

}
